import React, { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import Header from '../components/Header';
import MobileBottomNav from '../components/MobileBottomNav';
import { useRestaurant } from '../context/RestaurantContext';
import ScrollToTop from './ScrollToTop';

const PublicShell: React.FC = () => {
  const location = useLocation();
  const { settings, theme } = useRestaurant();
  const isDetailPage = location.pathname.startsWith('/item/');

  useEffect(() => {
    document.title = `${settings.name} Menu`;
    const faviconHref = settings.faviconImage || settings.logoImage || '/vite.svg';
    const existingIcon =
      document.querySelector("link[rel='icon']") || document.createElement('link');
    existingIcon.setAttribute('rel', 'icon');
    existingIcon.setAttribute('href', faviconHref);
    if (!existingIcon.parentNode) {
      document.head.appendChild(existingIcon);
    }

    const existingThemeColor =
      document.querySelector("meta[name='theme-color']") || document.createElement('meta');
    existingThemeColor.setAttribute('name', 'theme-color');
    existingThemeColor.setAttribute('content', settings.brandColors.primary);
    if (!existingThemeColor.parentNode) {
      document.head.appendChild(existingThemeColor);
    }
  }, [settings.brandColors.primary, settings.faviconImage, settings.logoImage, settings.name]);

  return (
    <div className="arab-shell min-h-screen" style={theme.cssVars}>
      <div className="arab-background-orb arab-background-orb-left" />
      <div className="arab-background-orb arab-background-orb-right" />
      <ScrollToTop />
      <Header />
      <main className={`overflow-x-hidden pt-20 ${isDetailPage ? '' : 'pb-20 md:pb-0'}`}>
        <Outlet />
      </main>
      <MobileBottomNav />
    </div>
  );
};

export default PublicShell;
